var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSandwitchMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 169,
    height: 86.312,
    viewBox: "0 0 169 86.312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_17",
    x: 0.005,
    y: 48.612,
    width: 168.995,
    height: 37.7,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rect\\xE1ngulo_13",
    x: 9.684,
    y: 27.156,
    width: 148,
    height: 32,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_17-2",
    x: 0,
    y: 0,
    width: 168.995,
    height: 37.7,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_38",
    "data-name": "Grupo 38",
    transform: "translate(-923.313 300.156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_36",
    "data-name": "Grupo 36",
    transform: "translate(24 54.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16",
    "data-name": "Trazado 16",
    d: "M3.668-6.994C6.61-9.242,15.534-8.851,28.4-8.851s11.083.862,23.407.862,13.818-.862,25.887-.862,8.779.862,21.242.862,16.248-.862,28.611-.862,19.72.21,21.641,1.208c.551.286,2.141,1.05,1.752,1.754-.894,1.618-5.352,3.678-5.352,3.678L0-2.082A10.3,10.3,0,0,1,3.668-6.994Z",
    transform: "translate(908.313 -289.983)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 899.31, -355)",
    filter: "url(#Trazado_17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_17-3",
    "data-name": "Trazado 17",
    d: "M3.7,5.46C6.663-1.058,15.66.076,28.629.076s11.173,2.5,23.6,2.5,13.93-2.5,26.1-2.5,8.85,2.5,21.414,2.5,16.379-2.5,28.842-2.5,19.88.61,21.816,3.5c.883,1.319.676,4.6.144,8.084-.534,3.5-1.512,7.16-1.512,7.16L0,19.7A51.264,51.264,0,0,1,3.7,5.46Z",
    transform: "translate(160 74.31) rotate(180)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 923.31, -300.16)",
    filter: "url(#Rect\\xE1ngulo_13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_13-2",
    "data-name": "Rect\\xE1ngulo 13",
    width: 130,
    height: 14,
    rx: 7,
    transform: "translate(18.68 33.16)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_37",
    "data-name": "Grupo 37",
    transform: "translate(1991.626 -574.844) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16-2",
    "data-name": "Trazado 16",
    d: "M3.668-6.994C6.61-9.242,15.534-8.851,28.4-8.851s11.083.862,23.407.862,13.818-.862,25.887-.862,8.779.862,21.242.862,16.248-.862,28.611-.862,19.72.21,21.641,1.208c.551.286,2.141,1.05,1.752,1.754-.894,1.618-5.352,3.678-5.352,3.678L0-2.082A10.3,10.3,0,0,1,3.668-6.994Z",
    transform: "translate(908.313 -289.983)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1, 0, 0, -1, 1068.31, -274.69)",
    filter: "url(#Trazado_17-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_17-4",
    "data-name": "Trazado 17",
    d: "M3.7,5.46C6.663-1.058,15.66.076,28.629.076s11.173,2.5,23.6,2.5,13.93-2.5,26.1-2.5,8.85,2.5,21.414,2.5,16.379-2.5,28.842-2.5,19.88.61,21.816,3.5c.883,1.319.676,4.6.144,8.084-.534,3.5-1.512,7.16-1.512,7.16L0,19.7A51.264,51.264,0,0,1,3.7,5.46Z",
    transform: "translate(9 6)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandwitchMenu);
export default __webpack_public_path__ + "static/media/sandwitchMenu.fcea99ea79849140fe433eb9785b35ac.svg";
export { ForwardRef as ReactComponent };